import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Utils from "utils";
import openNotification from "utils/notification";
import cloneDeep from "lodash";
import DriverFindingRuleService from "services/DriverFindingRuleService";

export const getDriverFindingRuleApi = createAsyncThunk(
  "setting/driver-finding-rule/getDriverFindingRuleApi",
  async (data, { rejectWithValue }) => {
    try {
      const response = await DriverFindingRuleService.getDriverFindingRuleApi();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const updateDriverFindingRuleApi = createAsyncThunk(
  "setting/driver-finding-rule/updateDriverFindingRuleApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await DriverFindingRuleService.updateDriverFindingRuleApi(data);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title")
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

const initialState = {
  loading: false,
  config: {},
};
export const settingDriverFindingRuleSlice = createSlice({
  name: "setting-driver-finding-rule",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDriverFindingRuleApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDriverFindingRuleApi.fulfilled, (state, action) => {
        state.loading = false;
        state.config = action.payload;
      })
      .addCase(getDriverFindingRuleApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(updateDriverFindingRuleApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateDriverFindingRuleApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateDriverFindingRuleApi.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { showLoading } = settingDriverFindingRuleSlice.actions;

export default settingDriverFindingRuleSlice.reducer;
